import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AjaxService } from '../services/ajax.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-grades',
  templateUrl: './grades.component.html',
  styleUrls: ['./grades.component.scss'],
})
export class GradesComponent implements OnInit {
  constructor(
    private _activeroute: ActivatedRoute,
    private _ajaxService: AjaxService,
    private _userService: UserService
  ) {}
  proficiency: Boolean = false;
  GrowthByGrade: Boolean = false;
  changeInNCE: Boolean = false;
  ark: Boolean = false;
  enrollment: Boolean = false;
  tableData: any[] = [];
  dataToDisplay: string = '';
  academicYearId: Number | null = 1;

  ngOnInit(): void {
    this._activeroute.params.subscribe((params) => {
      const receivedData = params['data'];
      this.dataToDisplay = receivedData;
      if (receivedData === 'ProficiencyGrade') {
        this.proficiency = true;
      } else if (receivedData === 'NCEChange') {
        this.changeInNCE = true;
      } else if (receivedData === 'enrollment') {
        this.enrollment = true;
      } else if (receivedData === 'ark') {
        this.ark = true;
      } else if (receivedData === 'GrowthByGrade') {
        this.GrowthByGrade = true;
      }
    });
    if (this._userService.getAcademicYearId().value != null) {
      this.academicYearId = this._userService.getAcademicYearId().value;
    }
    this.getGradesDataOnSchoolId();
  }

  /**
   * @author Manjunath
   * @uses to format data for Proficiency Grade and NCE Change table.
   */
  formatData(data: any[], keysNotToInclude: string[] = []) {
    const transformedData: any[] = [];
    data.forEach(
      (entry: { [x: string]: any; hasOwnProperty: (arg0: string) => any }) => {
        for (const key in entry) {
          if (entry.hasOwnProperty(key) && key.endsWith('Math') && !keysNotToInclude.includes(key)) {
            const grade = key.substring(0, key.length - 4); // Extract the grade from the key
            const transformedEntry = {
              grade,
              read: entry[`${grade}Read`],
              math: entry[key],
            };
            transformedData.push(transformedEntry);
          }
        }
      }
    );
    return transformedData;
  }

  /**
   * @author Manjunath
   * @uses to get data for grades.
   */
  getGradesDataOnSchoolId() {
    const request = {
      schoolId: this._userService.getSchoolId().value,
      academicYearId: this.academicYearId,
    };
    switch (this.dataToDisplay) {
      case 'ProficiencyGrade': {
        this._ajaxService
          .post('dashboard/getProficiencyByGrade', request)
          .then((response: any) => {
            if (response.statusCode == 200) {
              const keysNotToInclude = 
              response?.data[0]?.schoolType === 'ELEMENTARY' ? 
              ['G9Read', 'G9Math', 'G10Read', 'G10Math', 'G11Read', 'G11Math', 'G12Read', 'G12Math'] : 
              response?.data[0]?.schoolType === 'HIGH' ? ['G2Read', 'G2Math', 'G3Read', 'G3Math', 'G4Read', 'G4Math', 'G5Read', 'G5Math', 'G6Read', 'G6Math', 'G7Read', 'G7Math', 'G8Read', 'G8Math',] :
              []
              this.tableData = this.formatData(response.data, keysNotToInclude);
            }
          });
        break;
      }
      case 'GrowthByGrade': {
       this._ajaxService
          .post('dashboard/getGrowthByGrade', request)
          .then((response: any) => {
            if (response.statusCode == 200) {
              const keysNotToInclude = 
              response?.data[0]?.schoolType === 'ELEMENTARY' ? 
              ['G9Read', 'G9Math', 'G10Read', 'G10Math', 'G11Read', 'G11Math', 'G12Read', 'G12Math'] : 
              response?.data[0]?.schoolType === 'HIGH' ? ['G2Read', 'G2Math', 'G3Read', 'G3Math', 'G4Read', 'G4Math', 'G5Read', 'G5Math', 'G6Read', 'G6Math', 'G7Read', 'G7Math', 'G8Read', 'G8Math',] :
              []
              this.tableData = this.formatData(response.data, keysNotToInclude);
            }
          });
        break;
      }
      case 'enrollment': {
        this._ajaxService.post("dashboard/getenrollmentByGrade", request).then((response: any) => {
          if(response.statusCode == 200) {
            const transformedData:any[] = [];
            const keysNotToInclude = ['id', 'schoolId', 'createdAt', 'updatedAt', 'isDeleted', 'academicYearId']
            response.data.forEach((entry: { [x: string]: any; hasOwnProperty: (arg0: string) => any; }) => {
                for (const key in entry) {
                    if (entry.hasOwnProperty(key) && !keysNotToInclude.includes(key)) {
                      const splitKey = key.toUpperCase().split('EL')[1]
                      const UpdatedKey = splitKey ? `EL-${splitKey}` : `HS-${key.toUpperCase().split('HS')[1]}`
                      transformedData.push({ grade: UpdatedKey, count: entry[key] });
                    }
                }
            });
            this.tableData = transformedData
          }
        })
        break;
      }
      case 'ark':
        this._ajaxService
          .post('dashboard/getARKproficiencyByGrade', request)
          .then((response: any) => {
            if (response.statusCode == 200) {
              const transformedData: any[] = [];
              response.data.forEach(
                (entry: {
                  [x: string]: any;
                  hasOwnProperty: (arg0: string) => any;
                }) => {
                  for (const key in entry) {
                    if (entry.hasOwnProperty(key) && key.endsWith('High')) {
                      const grade = key.substring(5, key.length - 4); // Extract the grade from the key
                      const transformedEntry: any = {};
                      transformedEntry.grade = `G${grade}`;
                      transformedEntry.high = entry[key];
                      transformedEntry.med = entry[`Grade${grade}Med`];
                      transformedEntry.low = entry[`Grade${grade}Low`];
                      transformedData.push(transformedEntry);
                    }
                  }
                }
              );
              this.tableData = transformedData;
            }
          });
        break;

      default:
        break;
    }
  }
}



// CREATE TABLE `csipsa`.`EnrollmentByGrade` (
//   `id` BIGINT UNSIGNED NOT NULL AUTO_INCREMENT,
//   `schoolId` BIGINT UNSIGNED NOT NULL,
//   `academicYearId` INT NOT NULL,
//   `Elpk2` INT NULL,
//   `Elpk3` INT NULL,
//   `Elpk4` INT NULL,
//   `Elkind` INT NULL,
//   `El1` INT NULL,
//   `El2` INT NULL,
//   `El3` INT NULL,
//   `El4` INT NULL,
//   `El5` INT NULL,
//   `El6` INT NULL,
//   `El7` INT NULL,
//   `El8` INT NULL,
//   `HS9` INT NULL,
//   `HS10` INT NULL,
//   `HS11` INT NULL,
//   `HS12` INT NULL,
//   `createdAt` DATETIME NULL DEFAULT NOW(),
//   `updatedAt` DATETIME NULL,
//   PRIMARY KEY (`id`),
//   UNIQUE INDEX `id_UNIQUE` (`id` ASC) VISIBLE);
